export default __webpack_public_path__ + "static/media/popup-cark.4d2e16b4.png";